import { addModal } from 'weblite-web-modal-viewer'
import { CreateCourseTourStartDialog } from './create-course-tour-start-dialog'

const COMPONENT_ID = 'createCourseTourStartDialog'

export function showCreateCourseTourStartDialog() {
  addModal({ id: COMPONENT_ID })
}

export default {
  [COMPONENT_ID]: {
    Component: CreateCourseTourStartDialog,
  },
}
